import { Product } from '../types/product'

const normalize = (value?: string | null) => (value || '').trim().toLowerCase()

export function filterProductsByEcomCategory(items: Product[], aliases: string[]): Product[] {
  const normalizedAliases = aliases.map(alias => normalize(alias)).filter(Boolean)
  if (normalizedAliases.length === 0) return items

  return items.filter(product => {
    const productCategories = [
      product.categoryInternalName,
      product.categoryExternalName,
      product.productCategory,
    ].map(value => normalize(value))

    return productCategories.some(value => normalizedAliases.includes(value))
  })
}

export function sortByDisplayOrder(items: Product[]): Product[] {
  return [...items].sort((a, b) => (a.displayOrder ?? Infinity) - (b.displayOrder ?? Infinity))
}

export function categorySlice(items: Product[], aliases: string[], limit = 10): Product[] {
  return sortByDisplayOrder(filterProductsByEcomCategory(items, aliases)).slice(0, limit)
}

export const COFFEE_ALIASES = ['coffee', 'kava', 'кава']
export const DRIP_ALIASES = ['drip', 'dripi', 'дріпи', 'дрипи']
export const CAPSULE_ALIASES = ['kapsuli', 'капсули', 'капсула']
